import { render, staticRenderFns } from "./AgroTableDefault.vue?vue&type=template&id=63989bc6&scoped=true&"
import script from "./AgroTableDefault.vue?vue&type=script&lang=ts&"
export * from "./AgroTableDefault.vue?vue&type=script&lang=ts&"
import style0 from "./agroTableDefault.scss?vue&type=style&index=0&id=63989bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63989bc6",
  null
  
)

export default component.exports